/**
 * @generated SignedSource<<4f09f2e897fcdc7d5a280eafa55296d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsCarousel_item$data = {
  readonly collectionModule: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_items">;
        } | null;
      } | null> | null;
      readonly totalResults: number | null;
    } | null;
    readonly linkData: {
      readonly isLinkable: boolean | null;
      readonly path: string | null;
    };
    readonly name: string | null;
  } | null;
  readonly isArt: boolean | null;
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpRespSimilarItemsCarousel_item";
};
export type PdpRespSimilarItemsCarousel_item$key = {
  readonly " $data"?: PdpRespSimilarItemsCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsCarousel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionModule",
      "kind": "LinkedField",
      "name": "collectionModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "CollectionItemsConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CollectionItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "priceBookName",
                          "variableName": "priceBookName"
                        },
                        {
                          "kind": "Variable",
                          "name": "userCountryCode",
                          "variableName": "userCountryCode"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "PdpRespProductTileCarousel_items"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:5)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkable",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "563e305e9942d4355f45c1ad43444d22";

export default node;
